// Lib
import React from 'react';

// Components
import { SizeSelector } from '../components/SizeSelector';
import { Input } from '@components/ui/input';

// Types
import type {
  OrganizationAnswers,
  OrganizationErrors,
} from '../../model/useCreateOrganization';

interface CompanyInfoStepProps {
  answers: OrganizationAnswers;
  error: OrganizationErrors;
  onChange: (name: string, value: string) => void;
  onSetError: (name: string, value: string) => void;
}

export const CompanyInfoStep: React.FC<CompanyInfoStepProps> = ({
  answers,
  error,
  onChange,
  onSetError,
}) => (
  <>
    <h1 className="mb-12 text-center text-2xl font-bold tracking-tight text-foreground">
      {`Help us understand your company better :)`}
    </h1>
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4">
        <p className="text-center text-sm font-medium text-foreground">
          Company name
        </p>
        <Input
          type="text"
          name="name"
          placeholder="Company name"
          aria-invalid={Boolean(error?.name)}
          onChange={(field) => {
            if (error?.name) onSetError('name', '');
            onChange('name', field.target.value);
          }}
          value={answers?.name}
        />
        {error?.name && (
          <p className="text-xs text-marble-red-500">{error.name}</p>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <p className="text-center text-sm font-medium text-foreground">
          Your website
        </p>
        <Input
          type="text"
          name="website"
          placeholder="companyname.com"
          aria-invalid={Boolean(error?.website)}
          onChange={(field) => {
            if (error?.website) onSetError('website', '');
            onChange('website', field.target.value);
          }}
          value={answers?.website}
        />
        {error?.website && (
          <p className="text-xs text-marble-red-500">{error.website}</p>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <p className="text-center text-sm font-medium text-foreground">
          How big is your company ?
        </p>
        <SizeSelector size={answers?.size} onChange={onChange} />
      </div>
    </div>
  </>
);
